import { GENERIC_ERROR_MESSAGE, SUBSCRIPTION_ERROR_MESSAGE } from 'src/constants/messages';

// Maps backend error codes (both the 200-`failed` body `code` and thrown-exception `error` codes)
// to user-facing copy. Raw backend strings are never shown to the user.
const MESSAGES: Record<string, string> = {
  demo_phone: "The phone number you entered is a demo/test number and can't receive real messages.",
  invalid_phone: 'The phone number you entered looks invalid. Please check it and try again.',
  contact_opted_out: "This contact has opted out, so the test wasn't sent.",
  blocked_as_spam: 'The carrier blocked this message as spam. Try adjusting the wording.',
  telnyx_error: GENERIC_ERROR_MESSAGE,
  blocklist_match: 'Your message contains words or phrases restricted by carriers. Please edit it and try again.',
  no_active_subscription: SUBSCRIPTION_ERROR_MESSAGE,
  validation: "This test message can't be sent yet. Please check your company phone number and the recipient.",
};

export function testSendErrorMessage(code: string | null | undefined): string {
  if (code != null && MESSAGES[code] != null) {
    return MESSAGES[code];
  }
  return GENERIC_ERROR_MESSAGE;
}
